module.exports = __webpack_public_path__ + "img/f2.bc37b203.png";